import React, { useEffect, useState } from 'react';
import api from '../../services/api';

function MeusCursos() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/my-courses')
            .then(res => {
                setCourses(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    return (
        <div>
            <div className="dashboard-header">
                <h1>Meus Cursos</h1>
                <p>Acesse seus materiais e aulas.</p>
            </div>

            {loading ? (
                <p>Carregando cursos...</p>
            ) : courses.length === 0 ? (
                <div className="dashboard-card">
                    <p>Você ainda não possui cursos.</p>
                </div>
            ) : (
                <div className="card-grid">
                    {courses.map(course => (
                        <div key={course.id} className="dashboard-card">
                            <div style={{
                                height: '150px',
                                backgroundColor: '#eee',
                                borderRadius: '8px',
                                marginBottom: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#999'
                            }}>
                                {course.thumbnail ? <img src={course.thumbnail} alt={course.title} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} /> : 'Sem Imagem'}
                            </div>
                            <h3 style={{ marginBottom: '0.5rem' }}>{course.title}</h3>
                            <span style={{
                                display: 'inline-block',
                                padding: '0.2rem 0.6rem',
                                background: 'rgba(255, 126, 175, 0.1)',
                                color: 'var(--primary-color)',
                                borderRadius: '20px',
                                fontSize: '0.8rem',
                                marginBottom: '1rem'
                            }}>
                                {course.type || 'Curso'}
                            </span>

                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', marginBottom: '0.3rem' }}>
                                    <span>Progresso</span>
                                    <span>0%</span>
                                </div>
                                <div style={{ background: '#eee', height: '6px', borderRadius: '3px', marginBottom: '1.5rem' }}>
                                    <div style={{ width: '0%', background: 'var(--primary-color)', height: '100%', borderRadius: '3px' }}></div>
                                </div>
                                <button className="btn-primary" style={{ width: '100%' }}>
                                    Assistir
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MeusCursos;
